import Nullstack from 'nullstack';
export default function IconTractor({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-tractor",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "7",
    cy: "15",
    r: "4"
  }), "   ", Nullstack.element("line", {
    x1: "7",
    y1: "15",
    x2: "7",
    y2: "15.01"
  }), "   ", Nullstack.element("circle", {
    cx: "19",
    cy: "17",
    r: "2"
  }), "   ", Nullstack.element("line", {
    x1: "10.5",
    y1: "17",
    x2: "17",
    y2: "17"
  }), "   ", Nullstack.element("path", {
    d: "M20 15.2v-4.2a1 1 0 0 0 -1 -1h-6l-2 -5h-6v6.5"
  }), "   ", Nullstack.element("path", {
    d: "M18 5h-1a1 1 0 0 0 -1 1v4"
  }), " ");
}